import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, ViewContainerRef } from '@angular/core';
import { BaseComponent } from '../../base.component';
export var TabConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value);
    }
    return value;
};
export var TabArrayConverter = function (value) {
    if (typeof value === 'string') {
        return JSON.parse(value);
    }
    return value;
};
// TODO: Remove this. Applications should do tabs on their own.
var TabsComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TabsComponent, _super);
    function TabsComponent(_vcr, cdr) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.cdr = cdr;
        _this.tabChanged = new EventEmitter();
        _this._tabs = [];
        _this.activateTab = function (tab) {
            if (typeof tab === 'string') {
                tab = _this.tabs.find(function (t) { return t.name === tab; });
            }
            var pt = tab;
            if (pt && _this.activeTab.name !== pt.name) {
                _this.tabs.forEach(function (t) {
                    if (t.name !== pt.name) {
                        t.active = false;
                    }
                    else {
                        t.active = true;
                    }
                });
                _this.tabChanged.emit(_this.activeTab);
                _this.cdr.detectChanges();
            }
        };
        _this.registerEvent('tabchanged', _this.tabChanged);
        return _this;
    }
    Object.defineProperty(TabsComponent.prototype, "includeGoogleAnalytics", {
        get: function () { return false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabsComponent.prototype, "tabs", {
        get: function () {
            return this._tabs;
        },
        set: function (value) {
            this._tabs = this.convertToTabArray(value);
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabsComponent.prototype, "activeTab", {
        get: function () { return this.tabs.find(function (t) { return t.active; }); },
        enumerable: true,
        configurable: true
    });
    TabsComponent.prototype.convertToTabArray = function (value) {
        var tabArray = [];
        if (typeof value === 'string') {
            tabArray = JSON.parse(value);
        }
        else {
            tabArray = value;
        }
        tabArray.forEach(function (tab) {
            if (tab.isVisible === undefined) {
                tab.isVisible = true;
            }
            if (tab.active === undefined) {
                tab.active = false;
            }
        });
        return tabArray;
    };
    return TabsComponent;
}(BaseComponent));
export { TabsComponent };
